(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  function syncFooter() { document.querySelectorAll('.vc-footer-menu').forEach(menu => { menu.open = !mobile.matches; }); }
  syncFooter(); mobile.addEventListener('change', syncFooter);
  document.querySelectorAll('a[href]').forEach(link => {
    try { const url = new URL(link.getAttribute('href'), location.href); if (url.hostname === '6r63y1-ri.myshopify.com') link.setAttribute('href', url.pathname + url.search + url.hash); } catch (_) {}
  });
})();


(() => {
  const context = document.querySelector('.vc-search-vehicle');
  if (context) {
    const params = new URLSearchParams(location.search);
    const make = params.get('vehicle_make'), model = params.get('vehicle_model');
    if (make && model) { context.textContent = context.dataset.vehicleBrowse + ' ' + make + ' / ' + model; context.hidden = false; }
  }
  const bar = document.getElementById('vcSticky');
  if (!bar) return;
  document.body.appendChild(bar);
  const button = bar.querySelector('#vcStickyBtn'), price = bar.querySelector('#vcStickyPrice');
  const info = document.querySelector('.product__info-container');
  if (!button || !price || !info) return;
  function sync() {
    const main = info.querySelector('button[name="add"]');
    const prices = info.querySelector('.price');
    const amount = prices && (prices.classList.contains('price--on-sale') ? prices.querySelector('.price-item--sale') : prices.querySelector('.price__regular .price-item--regular'));
    price.textContent = amount ? amount.textContent.trim() : '';
    button.disabled = !main || main.disabled || main.getAttribute('aria-disabled') === 'true';
    const label = main && main.querySelector('span');
    button.textContent = button.disabled && label ? label.textContent.trim() : button.dataset.addLabel;
  }
  sync();
  new MutationObserver(sync).observe(info, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
  button.addEventListener('click', () => { const main=info.querySelector('button[name="add"]'); if(main && !main.disabled) main.click(); });
})();

(() => {
  const link = document.getElementById('vc-find-link');
  const footer = document.querySelector('footer.footer');
  if (!link || !footer || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(entries => {
    link.classList.toggle('vc-find-link--hidden', entries[0].isIntersecting);
  }, {threshold: 0}).observe(footer);
})();
